import { render } from "./CustomerDetails.vue?vue&type=template&id=d06515c6&ts=true"
import script from "./CustomerDetails.vue?vue&type=script&lang=ts"
export * from "./CustomerDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__